import React from 'react'
import qs from 'qs'
import { buscarVendaOffline, buscarPedidoSincronizado } from '../../util/offlineStorage'

function formatarReal(valor) {
  return Number(valor || 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
}

function labelTipoEmissao(tipo) {
  const mapa = {
    INTEIRA:         'Inteira',
    MEIA:            'Meia',
    GRATUIDADE:      'Gratuidade',
    CRIANCA:         'Criança',
    IDOSO:           'Idoso',
    ESTUDANTE:       'Estudante',
    DEFICIENTE:      'Deficiente',
    ACOMPANHANTE:    'Acompanhante',
    VALOR_COMBINADO: 'Valor combinado',
    CORTESIA:        'Cortesia',
  }
  return mapa[tipo] || tipo || '—'
}

function labelFormaPagamento(tipo) {
  const mapa = {
    DINHEIRO:       'Dinheiro',
    CARTAO_CREDITO: 'Cartão de crédito',
    CARTAO_DEBITO:  'Cartão de débito',
    PIX:            'Pix',
    TRANSFERENCIA:  'Transferência',
    CHEQUE:         'Cheque',
    LINK_PAGAMENTO: 'Link de pagamento',
    TEF:            'TEF',
    POS:            'POS',
    CORTESIA:       'Cortesia',
  }
  return mapa[tipo] || tipo || '—'
}

export default class PainelReciboVendaOffline extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      venda: null,
      pedidoId: null,
      carregando: true,
      erro: null,
    }
    this._intervalo = null
  }

  componentDidMount() {
    const params = qs.parse(this.props.history.location.search, { ignoreQueryPrefix: true })
    const chave = params.chave
    if (!chave) {
      this.setState({ carregando: false, erro: 'Chave da venda offline não informada.' })
      return
    }

    buscarVendaOffline(chave)
      .then(venda => {
        if (!venda) {
          this.setState({ carregando: false, erro: 'Venda offline não encontrada. Pode já ter sido sincronizada.' })
          return
        }
        const pedidoId = buscarPedidoSincronizado(chave)
        this.setState({ venda, pedidoId, carregando: false })
        this._intervalo = setInterval(() => this._verificarSync(chave), 5000)
      })
      .catch(() => this.setState({ carregando: false, erro: 'Erro ao carregar venda offline.' }))
  }

  componentWillUnmount() {
    if (this._intervalo) clearInterval(this._intervalo)
  }

  _verificarSync(chave) {
    const pedidoId = buscarPedidoSincronizado(chave)
    if (pedidoId && pedidoId !== this.state.pedidoId) {
      this.setState({ pedidoId })
      clearInterval(this._intervalo)
      this._intervalo = null
    }
  }

  _reservasPorSentido(sentido) {
    const { venda } = this.state
    if (!venda || !venda.reservas) return []
    return venda.reservas.filter(r => r.sentido === sentido)
  }

  _totalFormas() {
    const { venda } = this.state
    if (!venda || !venda.formasPagamentoDto) return 0
    return venda.formasPagamentoDto.reduce((acc, f) => acc + Number(f.valor || 0), 0)
  }

  _somarReservas(campo) {
    const { venda } = this.state
    if (!venda || !venda.reservas) return 0
    return venda.reservas.reduce((acc, r) => acc + Number(r[campo] || 0), 0)
  }

  exibirLimiteCupom() {
    return <div className="printer-element">--</div>
  }

  linha() {
    return <hr style={{ borderStyle: 'dashed', borderWidth: 3 }} />
  }

  exibirCabecalho(dv) {
    return (
      <React.Fragment>
        <tr>
          <th className="title" colSpan="3">
            {dv.empresaNome || 'Venda Offline'}
          </th>
        </tr>
        <tr>
          <th colSpan="3">Ref.: {(this.state.venda.idChaveOffline || '').substring(0, 16)}...</th>
        </tr>
        <tr>
          <th className="ttu" colSpan="3">
            <b>VENDA OFFLINE</b>
          </th>
        </tr>
      </React.Fragment>
    )
  }

  exibirDadosViagem(dadosViagem, sentido) {
    if (!dadosViagem) return null
    const reservas = this._reservasPorSentido(sentido)
    if (reservas.length === 0) return null

    const dv = this.state.venda.dadosViagem || {}
    const rota = dv.origemNome && dv.destinoNome
      ? `${dv.origemNome} → ${dv.destinoNome}`
      : ''

    return (
      <React.Fragment>
        <tr className="top">
          <td colSpan="3"><b>{sentido === 'IDA' ? '▶ IDA' : '◀ VOLTA'}</b></td>
        </tr>
        {rota ? (
          <tr>
            <td colSpan="3">Rota: {rota}</td>
          </tr>
        ) : null}
        <tr>
          <td colSpan="3">Data/Hora embarque: {dadosViagem.dataPartida} {dadosViagem.horaPartida}</td>
        </tr>
        {dadosViagem.embarque ? (
          <tr>
            <td colSpan="3">Local de embarque: {dadosViagem.embarque}</td>
          </tr>
        ) : null}
        {dadosViagem.veiculo ? (
          <tr>
            <td colSpan="3">
              Veículo: {dadosViagem.veiculo}
              {dadosViagem.nomePrestador ? ` (${dadosViagem.nomePrestador})` : ''}
            </td>
          </tr>
        ) : null}
        {reservas.map((r, idx) => this.exibirPassageiro(r, idx))}
      </React.Fragment>
    )
  }

  exibirPassageiro(r, idx) {
    const p = r.passageiroDto || {}
    return (
      <React.Fragment key={idx}>
        <tr className="top">
          <td colSpan="3">Passageiro: <b>{p.nome || '—'}</b></td>
        </tr>
        <tr>
          <td colSpan="3">Poltrona: {r.numeroPoltrona || 'Sem poltrona definida'}</td>
        </tr>
        <tr>
          <td colSpan="3">Tipo emissão: {labelTipoEmissao(p.tipoEmissao)}</td>
        </tr>
        {p.cpfPassageiro ? (
          <tr>
            <td colSpan="3">CPF: {p.cpfPassageiro}</td>
          </tr>
        ) : null}
        {p.documentoComFoto ? (
          <tr>
            <td colSpan="3">Doc. embarque: {p.documentoComFoto}</td>
          </tr>
        ) : null}
      </React.Fragment>
    )
  }

  exibirTotais() {
    const tarifa  = this._somarReservas('valor')
    const pedagio = this._somarReservas('pedagio')
    const taxa    = this._somarReservas('taxaEmbarque')
    const total   = this._totalFormas()
    const { venda, pedidoId } = this.state

    return (
      <tfoot>
        <tr className="sup ttu p--0">
          <td colSpan="3"><b>Totais</b></td>
        </tr>
        <tr className="ttu">
          <td colSpan="2">Tarifa</td>
          <td align="right">{formatarReal(tarifa)}</td>
        </tr>
        {pedagio > 0 ? (
          <tr className="ttu">
            <td colSpan="2">Pedágio</td>
            <td align="right">{formatarReal(pedagio)}</td>
          </tr>
        ) : null}
        {taxa > 0 ? (
          <tr className="ttu">
            <td colSpan="2">Taxa de embarque</td>
            <td align="right">{formatarReal(taxa)}</td>
          </tr>
        ) : null}
        <tr className="ttu">
          <td colSpan="2"><b>Valor total pago</b></td>
          <td align="right"><b>{formatarReal(total)}</b></td>
        </tr>
        {venda.formasPagamentoDto && venda.formasPagamentoDto.length > 0 ? (
          <React.Fragment>
            <tr className="sup ttu p--0">
              <td colSpan="3"><b>Pagamentos</b></td>
            </tr>
            {venda.formasPagamentoDto.map((f, idx) => (
              <tr key={idx} className="ttu">
                <td colSpan="2">{labelFormaPagamento(f.codigoTipo || f.tipo)}</td>
                <td align="right">{formatarReal(f.valor)}</td>
              </tr>
            ))}
          </React.Fragment>
        ) : null}
        <tr className="sup">
          <td colSpan="3" align="center">
            {pedidoId
              ? `Venda sincronizada. Pedido #${pedidoId}`
              : (
                <React.Fragment>
                  <strong>⚠️ Venda realizada em modo offline</strong><br />
                  No momento, esta passagem foi emitida sem conexão com o sistema e será sincronizada automaticamente assim que a internet for restabelecida.<br /><br />
                  <strong>Importante:</strong> após a sincronização, a poltrona selecionada poderá sofrer alteração devido à atualização de disponibilidade em tempo real.<br />
                  Caso isso ocorra, nossa equipe ou o motorista poderá orientá-lo(a) sobre a nova poltrona no momento do embarque.
                </React.Fragment>
              )}
          </td>
        </tr>
      </tfoot>
    )
  }

  render() {
    const { venda, pedidoId, carregando, erro } = this.state

    if (carregando) {
      return <div className="recibo-offline-loading">Carregando recibo...</div>
    }

    if (erro) {
      return (
        <div className="row internas col-md-12 d-flex justify-content-center">
          <div className="recibo-offline-erro">
            <p>{erro}</p>
            <button className="vx-btn-primary" onClick={() => this.props.history.push('/painel-destinos')}>
              Nova venda
            </button>
          </div>
        </div>
      )
    }

    const dv = venda.dadosViagem || {}

    return (
      <div className="page-recibo-offline row internas col-md-12 d-flex justify-content-center">
        <div className="col-md-8">

          {pedidoId ? (
            <div className="recibo-offline-banner recibo-offline-banner--ok">
              <i className="material-icons">check_circle</i>
              {' Venda sincronizada! Pedido '}
              <strong>#{pedidoId}</strong>
              {' — '}
              <a href={`/recibo-passagem?pedido=${pedidoId}`}>Ver recibo completo</a>
            </div>
          ) : venda.erroSync ? (
            <div className="recibo-offline-banner recibo-offline-banner--erro">
              <i className="material-icons">error</i>
              {' Falha na sincronização: '}{venda.erroSync}
            </div>
          ) : (
            <div className="recibo-offline-banner recibo-offline-banner--pendente">
              <i className="material-icons">sync</i>
              {' Venda pendente de sincronização — será confirmada quando a internet retornar'}
            </div>
          )}

          <div className="recibo-offline-print-area">
            {this.exibirLimiteCupom()}

            <table className="printer-ticket">
              <thead>
                {this.exibirCabecalho(dv)}
              </thead>
              <tbody>
                {this.exibirDadosViagem(dv.ida, 'IDA')}
                {this.exibirDadosViagem(dv.volta, 'VOLTA')}
              </tbody>
              {this.exibirTotais()}
            </table>

            {this.exibirLimiteCupom()}
            {this.linha()}
          </div>

          <div className="recibo-offline-acoes">
            <button className="btn btn-laranja mr-2" onClick={() => window.print()}>
              <i className="material-icons mr-1" style={{ fontSize: '18px', verticalAlign: 'middle' }}>print</i>
              Imprimir
            </button>
            <button className="vx-btn-primary" onClick={() => this.props.history.push('/painel-destinos')}>
              Nova venda
            </button>
          </div>

        </div>
      </div>
    )
  }
}
